import { Box, Button, Container, Typography } from "@mui/material";
// import PersonIcon from "@mui/icons-material/Person";
import EmailIcon from "@mui/icons-material/Email";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
// import ContentCopyIcon from "@mui/icons-material/ContentCopy";
// import FileCopyOutlined from "@mui/icons-material/FileCopyOutlined";
// import ContentPaste from "@mui/icons-material/ContentPaste";
import { useEffect, useMemo, useState } from "react";

function UserDetails({ property }) {
  const [accessed, setAccessed] = useState(false);

  const [user, domain] = property.email.split("@");
  // Build the obfuscated preview
  // const preview = `${user.charAt(0)}***@${domain.charAt(0)}***.${domain
  //   .split(".")
  //   .slice(1)
  //   .join(".")
  //   .charAt(0)}***`;
  const preview = `${user[0]}•••@${domain.split(".")[0][0]}•••.${
    domain.split(".")[1][0]
  }•••`;

  const encoded = useMemo(
    () => btoa([...property.email].reverse().join("")),
    [property.email]
  );

  // Temporary display
  useEffect(() => {
    if (accessed) {
      const timer = setTimeout(() => setAccessed(false), 5000);
      return () => clearTimeout(timer);
    }
  }, [accessed]);

  const handleAccess = async () => {
    // Add CAPTCHA verification here
    const decoded = atob(encoded).split("").reverse().join("");
    await navigator.clipboard.writeText(decoded);
    setAccessed(true);
  };

  return (
    <Container sx={{ marginBottom: 5 }}>
      <Box>
        <Typography variant="h5" component="h2" sx={{ marginBottom: 1 }}>
          Property Owner
        </Typography>
      </Box>
      {/* Property Owner Name */}
      <Box sx={{ marginBottom: 1 }}>
        {(property.firstName || property.lastName) && (
          <Typography
            variant="body1"
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            <AccountCircleIcon fontSize="medium" color="action" />
            {property.firstName} {property.lastName}
          </Typography>
        )}
        <div style={{ display: "none" }} data-honeypot="contact@example.com" />
      </Box>
      {/* Property Owner Email */}
      <Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <EmailIcon fontSize="medium" color="action" />
          {!accessed ? (
            <Button
              onClick={handleAccess}
              size="small"
              variant="outlined"
              color="inherit"
              // startIcon={<ContentCopyIcon />}
              // startIcon={<FileCopyOutlined />}
              // startIcon={<ContentPaste />}
            >
              Copy Email
            </Button>
          ) : (
            <>
              <Typography variant="body1">✓ Copied to clipboard</Typography>
              <Typography variant="body2" color="text.secondary">
                {preview}
              </Typography>
            </>
          )}
        </Box>
      </Box>
    </Container>
  );
}

export default UserDetails;
